import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import { HTMLContent } from '../components/Content'
import LandingPageTemplate from './LandingPageTemplate'
import { defineCustomElements as deckDeckGoHighlightElement } from "@deckdeckgo/highlight-code/dist/loader";

const LandingPage = ({ data }) => {

  useEffect(() => {
    deckDeckGoHighlightElement();
  })

  const { markdownRemark: page } = data

  let shouldIndex = true;

  if (page.frontmatter?.noIndex) {
    shouldIndex = false;
  }

  return (
    <Layout title={page.frontmatter.title} description={page.frontmatter.description} enableIndexing={shouldIndex}>
      <LandingPageTemplate
        content={page.html}
        contentComponent={HTMLContent}
        title={page.frontmatter.title}
        description={page.frontmatter.description}
        tools={page.frontmatter.tools}
        logos={page.frontmatter.logos}
        image={page.frontmatter.image}
        features={page.fields.features}
        faq={page.fields.faq}
        sections={page.fields.sections}
        testimonials={page.fields.testimonials}
        citations={page.frontmatter.citations}
        related={page.frontmatter.related}
        cta={page.frontmatter.cta}
        ctaSubtitle={page.frontmatter.ctaSubtitle}
        ctaButtonTitle={page.frontmatter.ctaButtonTitle}
        ctaButtonLink={page.frontmatter.ctaButtonLink}
      />
    </Layout>
  )
}

LandingPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default LandingPage

export const pageQuery = graphql`
  query LandingPageByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      fields {
        features {
          title
          compact
          items {
            url
            icon
            title
            text
          }
        }
        faq {
          title
          text
        }
        sections {
          text
        }
        testimonials {
          featured
          logoUrls
          name
          author
          quote
          text
        }
      }
      frontmatter {
        title
        description
        noIndex
        tools {
          compare {
            enabled
            title
            subtitle
          }
          try {
            enabled
            title
          }
          pricing_calculator {
            enabled
          }
          subscribe {
            enabled
            title
            subtitle
            listId
          }
        }
        logos {
          url
          title
        }
        image
        features {
          title
          compact
          items {
            url
            icon
            title
            text
          }
        }
        faq {
          title
          text
        }
        sections {
          text
        }
        testimonials {
          featured
          logoUrls
          name
          author
          quote
          text
        }
        citations {
          logoUrls
          name
          author
          url
          description
        }
        related {
          title
          description
          buttonLink
          buttonTitle
        }
        cta
        ctaSubtitle
        ctaButtonTitle
        ctaButtonLink
      }
    }
  }
`
